import { axios } from "@/utils"

export default {
    createAccount(payload) {
        return axios.post(`/v2/users/create/ `, payload)
    },

    getAuthToken(username, password) {
        return axios.post('/api/v1/get-token-auth/', { username, password })
    },

    getTokenFromSsoLogin(integration_id, token) {
        return axios.post('/v2/user/sso-integration/', {
            token: token,
            integration: integration_id
        })
    },

    convertAuthToken(payload) {
        return axios.post('/auth/convert-token/', payload)
    },

    convertIbiAuthToken(payload) {
        return axios.post('/accounts/ibi/convert-token/', payload)
    },

    getUserData() {
        return axios.get(`/v2/users/me/?include_perms=true`)
    },

    updateUser(payload) {
        return axios.patch(`/v2/users/me/`, payload)
    },

    resetPassword(payload) {
        return axios.post(`/api/v1/password/reset/`,
            payload)
    },

    changePassword(oldPassword, newPassword1, newPassword2) {
        return axios.post(`/api/v1/password/change/`, {
            'old_password': oldPassword,
            'new_password1': newPassword1,
            'new_password2': newPassword2
        })
    },

    getPaymentMethods() {
        return axios.get(`/payments/v1/stripe/payment-methods/`)
    },

    setDefaultPaymentMethod(paymentMethodId) {
        return axios.patch(`/payments/v1/stripe/payment-methods/${paymentMethodId}/set-default/`)
    },

    removePaymentMethod(paymentMethodId) {
        return axios.post(`/payments/v1/stripe/payment-methods/${paymentMethodId}/detach/`)
    },

    deleteAccount(password) {
        return axios.post(`/v1/users/me/delete/`, { password })
    }
}
